export default __webpack_public_path__ + "static/media/amazoncom.af512afa.png";